/**
 * List of events used by booking participants form widget
 *
 */
export const bookingParticipantsForm = {
  ITEM_FORM_VALIDATON_ERROR: 'bookingParticipantsForm.ItemFormValidationError'
}
